import styled from 'styled-components';
import { flexPosition, fontStyle } from '../../styles/mixins';
import {
  GRAY_DARKER,
  GRAY_MEDIUM,
  FONT_SIZE_5,
  FONT_WEIGHT_NORMAL,
  GRAY_LIGHTER_3,
  MAIN_COLOR,
  FONT_SIZE_7,
} from '../../styles/variables';
import { EmptyMessage } from '../VariationOptionForm/style';

export const Container = styled.div`
  background-color: ${GRAY_LIGHTER_3};
  height: 100%;
  position: relative;
`;

export const Content = styled.div`
  margin: 0 auto;
  min-height: 100%;
  padding: 20px 20px 0px;
  position: relative;
  text-align: left;
  width: 100%;
`;

export const Title = styled.h2`
  ${fontStyle(GRAY_DARKER, FONT_SIZE_5, FONT_WEIGHT_NORMAL)}
  margin-bottom: 10px;
  margin-top: 0;
`;

export const Text = styled.p`
  ${fontStyle(GRAY_MEDIUM, FONT_SIZE_7, FONT_WEIGHT_NORMAL)}
  width: 55%;
`;

export const Header = styled.div`
  padding-bottom: 20px;
  padding-left: 10px;
  margin-top: 10px;
  background-color: #fff;
`;

export const Footer = styled.div`
  height: 80px;
  width: 100%;
  padding: 15px;
  ${flexPosition({ align: 'center' })}
  justify-content: ${({ center }) => (center ? 'center' : 'space-between')};
  background-color: #fff;
`;

export const VariationsList = styled.div`
  ${flexPosition({ align: 'center', justify: 'flex-start' })}
  flex-direction: column;
  height: 380px;
  overflow-y: auto;
`;

export const VariationItemWrapper = styled.div`
  width: 100%;
  padding: ${({ isSelected }) => (isSelected ? `5px` : '7px')};
  margin-bottom: 10px;
  border-radius: 7px;
  cursor: pointer;
  border: ${({ isSelected }) => (isSelected ? `2px solid ${MAIN_COLOR}` : 'none')};
`;

export const FullLoader = styled.div`
  width: 100%;
  height: 100%;
  ${flexPosition({ align: 'center', justify: 'center' })}
`;

export const StyledEmptyMessage = styled(EmptyMessage)`
  max-width: 175px;
`;



// WEBPACK FOOTER //
// ./src/components/SelectVariationsModal/style.js